module.exports = __webpack_public_path__ + "static/geerntet-05-b9b0ded255c3dd6e126744664f670767.jpg";